'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { HiChevronRight } from 'react-icons/hi';
import clsx from 'clsx';
import GlowingButton from '../shared/GlowingButton';



type GlossaryItem = {
  term: string;
  definition: string;
  tags: string[];
  example?: string;
};

interface GlossaryPreviewProps {
  items: GlossaryItem[];
}

const GlossaryPreview = ({ items = [] }: GlossaryPreviewProps) => {
  const [expandedTerm, setExpandedTerm] = useState<string | null>(null);

    // Comment animasi untuk section
  // const { ref: sectionRef, isVisible: sectionVisible } =
  //   useIntersectionObserver({
  //     threshold: 0.1,
  //     triggerOnce: true,
  //   });

  // Comment animasi untuk header
  // const { ref: headerRef, isVisible: headerVisible } = useIntersectionObserver({
  //   threshold: 0.1,
  //   triggerOnce: true,
  // });

  // Comment animasi untuk button
  // const { ref: buttonRef, isVisible: buttonVisible } = useIntersectionObserver({
  //   threshold: 0.1,
  //   triggerOnce: true,
  // });

    // Fallback items matching the full glossary style - limited to 4 terms for preview
    const previewItems =
    items.length > 0
      ? items
          .slice(0, 4)
          .map((item) => ({
            ...item,
            tags: item.tags || [], // Ensure tags is always an array
          }))

          .sort((a, b) => a.term.localeCompare(b.term))
          : [
              {
                term: 'Akuisisi (Pengambilalihan)',
                definition:
                  'Suatu strategi bisnis untuk mengambil alih kontrol terhadap suatu PT yaitu dengan cara mengakuisisi saham ataupun aset dari PT sebuah PT.',
                tags: ['Hukum Perusahaan', 'M&A'],
                example:
                  'PT A mengakuisisi saham PT B sebesar 60% sehingga mengakibatkan berpindahnya kontrol terhadap PT B tersebut kepada PT A',
              },
              {
                term: 'Due Diligence',
                definition:
                  'Pemeriksaan aspek hukum perusahaan secara menyeluruh untuk mengidentifikasi potensi risiko hukum.',
                tags: ['Audit', 'Compliance'],
              },
              {
                term: 'Merger (Penggabungan)',
                definition:
                  'Perbuatan hukum yang dilakukan oleh satu perseroan atau lebih untuk menggabungkan diri dengan perseroan lain yang telah ada.',
                tags: ['Merger & Akuisisi', 'Restrukturisasi'],
                example:
                  'Merger antara Gojek dan Tokopedia pada tahun 2021 membentuk GoTo Group.',
              },
              {
                term: 'Perseroan Terbatas (PT)',
                definition:
                  'Badan hukum yang merupakan persekutuan modal, didirikan berdasarkan perjanjian antar 2 orang atau lebih dan melakukan kegiatan usaha dengan modal dasar yang seluruhnya terbagi dalam saham.',
                tags: ['Hukum Perusahaan', 'Badan Hukum'],
              },
            ].sort((a, b) => a.term.localeCompare(b.term));
  






  return (
    <section
      // ref={sectionRef as React.RefObject<HTMLElement>}
      className="w-full py-24 relative overflow-hidden glossary-preview-section opacity-100"
      // className={`w-full py-24 relative overflow-hidden glossary-preview-section ${
      //   sectionVisible ? 'opacity-100' : 'opacity-0'
      // } transition-opacity duration-500`}
    >
      {/* Comment Legal themed decorative elements */}
      {/* <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(0deg, rgba(16,185,129,0.08) 1px, transparent 1px)',
            backgroundSize: '100% 28px',
            opacity: 0.03,
          }}
        />

        <div className="absolute top-20 left-20 opacity-15">
          <div className="w-40 h-40 border-t-2 border-l-2 border-emerald-500/40 rounded-tl-md"></div>
        </div>

        <div className="absolute bottom-20 right-20 opacity-15">
          <div className="w-40 h-40 border-b-2 border-r-2 border-emerald-500/40 rounded-br-md"></div>
        </div>
      </div> */}

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="mb-12 max-w-2xl">
          <div className="flex items-center space-x-2 mb-2"></div>
          <h1
            // ref={headerRef as React.RefObject<HTMLHeadingElement>}
            className="mb-2 opacity-100"
            // className={`text-4xl md:text-5xl font-bold mb-2 ${
            //   headerVisible
            //     ? 'opacity-100 translate-y-0'
            //     : 'opacity-0 translate-y-4'
            // } transition-all duration-700 ease-out`}
          >
            Legal
            <span className="gradient-text"> Glossary</span>
          </h1>
          <p
            className="excerpt"
            // className={`text-neutral-400 text-sm md:text-base leading-relaxed ${
            //   headerVisible
            //     ? 'opacity-100 translate-y-0'
            //     : 'opacity-0 translate-y-4'
            // } transition-all duration-700 ease-out delay-100`}
          >
            Terms & Definitions
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8">
          {/* Glossary Items */}
          <div className="space-y-4 mb-10">
            {previewItems.map((item, index) => {
              // Comment animasi untuk item
              // const { ref, isVisible } = useIntersectionObserver({
              //   threshold: 0.1,
              //   triggerOnce: true,
              // });

              return (
                <div
                  key={item.term}
                  // ref={ref as React.RefObject<HTMLDivElement>}
                  className="group transition-all duration-200 opacity-100 translate-y-0"
                  // className={`group transition-all duration-200 ${
                  //   isVisible
                  //     ? 'opacity-100 translate-y-0'
                  //     : 'opacity-0 translate-y-4'
                  // } transition-all duration-500 ease-out`}
                  // style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <button
                    onClick={() =>
                      setExpandedTerm(
                        expandedTerm === item.term ? null : item.term
                      )
                    }
                    className={clsx(
                      'w-full flex items-center justify-between pt-4 rounded-lg transition-all duration-200 text-left',
                      expandedTerm === item.term ? '' : ''
                    )}
                  >
                    <div className="space-y-1 pt-4 flex-1">
                      <h3
                        className={clsx(
                          'underline-custom',
                          expandedTerm === item.term
                            ? 'inline-block underline-offset-2 decoration-white decoration-1'
                            : 'text-gray-200'
                        )}
                      >
                        {item.term}
                      </h3>
                      <p
                        className={clsx(
                          'p-item',
                          expandedTerm === item.term ? '' : 'line-clamp-3'
                        )}
                      >
                        {item.definition}
                      </p>
                      {expandedTerm === item.term && (
                        <div className="flex flex-wrap gap-2">
                          {item.tags.map((tag) => (
                            <span key={tag} className="tag-button-default mt-5">
                              #{tag}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                    <HiChevronRight
                      className={clsx(
                        'flex-shrink-0 w-5 h-5 text-gray-500 group-hover:text-emerald-400 transition-transform duration-200',
                        expandedTerm === item.term && 'rotate-90'
                      )}
                    />
                  </button>
                </div>
              );
            })}
          </div>

          {/* View All Button */}
          <div
            // ref={buttonRef as React.RefObject<HTMLDivElement>}
            className="text-center opacity-100 translate-y-0"
            // className={`text-center ${
            //   buttonVisible
            //     ? 'opacity-100 translate-y-0'
            //     : 'opacity-0 translate-y-4'
            // } transition-all duration-700 ease-out delay-300`}
          >
            <Link href="/glossary/" className="inline-block">
              <GlowingButton variant="small">View All Terms</GlowingButton>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlossaryPreview;
